module.exports = __webpack_public_path__ + "img/plan2.3a93e4da.png";